import { useState, useCallback } from 'react';
import { Product } from '../types';

interface UseImageLoaderProps {
  products: Product[];
  maxDisplayProducts?: number;
}

export function useImageLoader({ products, maxDisplayProducts = 6 }: UseImageLoaderProps) {
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

  const handleImageLoad = useCallback((index: number) => {
    setLoadedImages((prev) => new Set([...prev, index]));
  }, []);

  const displayProducts = products.slice(0, maxDisplayProducts);
  const allImagesLoaded = loadedImages.size === displayProducts.length;

  return {
    loadedImages,
    handleImageLoad,
    displayProducts,
    allImagesLoaded,
  };
}
